export default __webpack_public_path__ + "static/media/alert.c6fbf7f6.svg";